import { FC } from "react";
import { useTranslation } from "react-i18next";

import { LandingLayout, LoaderMuiLanding } from "@ryde/controls-landing";
import {
  CompanyScopeLandingsContextWrapper,
  ILandingPage,
  LandingCompanyIdEnum,
  useLandingInit,
} from "@ryde/utils-landings";

import { TnufaWrapper } from "./tnufa-wrapper.styled";

export const TnufaPage: FC<ILandingPage> = ({ companyId }) => {
  const { t } = useTranslation();
  const { landingInitData, isLoading } = useLandingInit({ companyId });
  return (
    <>
      {landingInitData && (
        <CompanyScopeLandingsContextWrapper
          companyId={landingInitData.companyId}
        >
          <TnufaWrapper>
            <LandingLayout stepsContainerId={LandingCompanyIdEnum.Tnufa} />
          </TnufaWrapper>
        </CompanyScopeLandingsContextWrapper>
      )}
      {isLoading && <LoaderMuiLanding loading text={t("ui.LOADING_DATA")} />}
    </>
  );
};
